<div class="l-top-navi">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-navi__inner l-top-navi__inner--has-progress">
        <div class="l-top-navi__back-area">
          <a
            id="ana-biz-statement-of-charges-select-sub-header-back"
            class="l-top-navi__back-link"
            [routerLink]="backUrl"
          >
            <span class="u-visually-hidden" innerHTML="{{ 'reader.goBackToPreviousPage' | staticMsg }}"></span>
          </a>
        </div>
        <div class="l-top-navi__heading-area clear-left-margin">
          <h1 class="l-top-navi__heading-text">
            <span class="c-text-with-tooltip">
              <span
                class="c-text-with-tooltip__text"
                [innerHTML]="'heading.anaBizJourneyStatementList' | staticMsg"
              ></span>
              <span class="c-text-with-tooltip__tooltip js-tooltip">
                <ng-container
                  *aswIfScreenSize="'SP'; else notSP"
                  [ngTemplateOutlet]="tooltip"
                  [ngTemplateOutletContext]="{ tooltipTop: -85 }"
                ></ng-container>
                <ng-template #notSP>
                  <ng-container
                    [ngTemplateOutlet]="tooltip"
                    [ngTemplateOutletContext]="{ tooltipTop: -65 }"
                  ></ng-container>
                </ng-template>
              </span>
            </span>
          </h1>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #tooltip let-tooltipTop="tooltipTop">
  <asw-tooltip
    iconImage="<img src=&quot;assets/images/icon_help_primary_24.svg&quot; alt=&quot;{{
      'm_static_message-alt.helpIcon2' | staticMsg
    }}&quot; width=&quot;20&quot; height=&quot;20&quot;>"
    [tooltipContent]="'tooltip.journeyStatementList' | staticMsg"
    [tooltipTop]="tooltipTop"
  ></asw-tooltip>
</ng-template>
